import { PluginListenerHandle, registerPlugin } from '@capacitor/core';

interface SessionID {
  sessionId: string | null;
}

interface IMParticleSessionManagerPlugin {
  getSessionId(): Promise<SessionID>;
  addListener(
    event: 'sessionStart' | 'sessionEnd',
    callback: (data: SessionID) => void
  ): PluginListenerHandle;
  addListener(
    event: 'sessionError',
    callback: (data: { error: string }) => void
  ): PluginListenerHandle;
}

export const MParticleSessionManagerPlugin = registerPlugin<IMParticleSessionManagerPlugin>(
  'MParticleSessionManagerPlugin'
);
